import React from 'react'
import './Footer.css'

const Footer = () => {
    return (
        <footer className="footer" >
            <span>R2S Version v1.2.7 (Sterling Check ap-south-1) </span>
        </footer>
    )
}

export default Footer